export default "__VITE_ASSET__BtSvS3or__"